// Fonction pour transformer les mentions dans le texte en éléments stylisés
export const renderMentions = (text) => {
    if (!text) return text

    // Remplacer @all
    let result = text.replace(/@all\b/gi, (match) => {
        return `<span class="mention mention-all">${match}</span>`
    })

    // Remplacer @username (y compris les noms avec espaces)
    result = result.replace(/@(\w+(?:\s+\w+)*)/gu, (match, username) => {
        if (username.toLowerCase() === 'all') {
            return match // Déjà géré ci-dessus
        }
        return `<span class="mention">@${username}</span>`
    })

    return result
}

// Composant React pour afficher un commentaire avec mentions
export const CommentWithMentions = ({ text, className = '' }) => {
    const htmlContent = renderMentions(text)

    return (
        <div
            className={`comment-text ${className}`}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
    )
}
